import React from "react";
import "./CardService.scss";
import { Link } from "react-router-dom";

const CardService = (props) => {
  const stringtitle = props.Title;

  const shortTitle = JSON.stringify(stringtitle);

  var alert = false;

  if (shortTitle.length > 20) {
    alert = true;
  }


  return (
    <Link to={`/Product/detail/${props.id}`}>
      <div className="main_cardss">
        <div className="first_elementss">
          <div className="sub_stye_card">
            <div className="icons">
              <img src={props.image} alt="" />
            </div>
            <div className="frame_content">
              {alert === true ? (
                <h3>{props.Title.substring(0, 21) + "..."}</h3>
              ) : (
                <h3>{props.Title}</h3>
              )}

              <p>{props.date}</p>
            </div>
          </div>
        </div>

        <div className="more_contact">
          <Link to={`/Product/detail/${props.id}`}></Link>
        </div>
      </div>
    </Link>
  );
};

export default CardService;
